import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { logout } from '../../redux/actions/authActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGift, faMapMarkerAlt, faCity, faStar, faGlobe, faBook, faBookOpen, faDownload, faGifts, faHandsHelping, faPhone, faRainbow, faShoppingCart, faStore, faVideo, faDashboard, faSeedling, faTicketAlt } from '@fortawesome/free-solid-svg-icons';

const VisiGiftFAQ = () => {
  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || 'User';

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    dispatch(logout());
    navigate('/visigift');
  };

  const handleMobileMenuToggle = () => {
    setIsMobileMenuOpen((prev) => !prev);
  };

  const menuButtons = [
    { label: 'Website', icon: faGlobe, link: '/roomanywhere' },
    // { label: 'Website', icon: faGlobe, link: '/visigift-company-website' },
    { label: 'Videos', icon: faVideo, link: '/wTube' },
    { label: 'Contact', icon: faPhone, link: '/visigift-company-contact' },
    { label: 'Form', icon: faBook, link: '/visigift-company-leadform' },
    { label: 'Buy', icon: faShoppingCart, link: '/orderflow-home' },
    { label: 'Brochure', icon: faBookOpen, link: '/visigift-company-brochure' },
    { label: 'App', icon: faDownload, link: '/visigift-company-appdownload' },
    { label: 'Stores', icon: faStore, link: '/visigift-company-store' },
  ];

  return (
    <div className="min-h-screen flex flex-col bg-black text-purple-100 font-sans">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#2a0f2f] border-b border-purple-800 px-4 py-2 flex items-center justify-between shadow-lg">
        <div className="flex flex-col">
          <div className="text-xl lg:text-2xl font-bold text-purple-400">🎁 VisiGift</div>
          <div className="text-[10px] lg:text-lg text-yellow-200">
            Rewarding Ads & Videos: Earn While You Watch & Shop Smart!
          </div>
        </div>

        {/* Desktop user controls */}
        <div className="hidden md:flex items-center gap-3">
          {isLoggedIn ? (
            <>
              <div className="text-xs text-left text-purple-300">{userName}</div>
              <button
                onClick={handleLogout}
                className="p-2 mt-2 rounded-md bg-rose-600 hover:bg-rose-700 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate('/login')}
                className="px-3 py-1 rounded-full border border-purple-700 text-sm text-purple-200 hover:bg-purple-900"
              >
                Login
              </button>
              <button
                onClick={() => navigate('/signup')}
                className="px-3 py-1 rounded-full bg-purple-500 text-white text-sm hover:bg-purple-400"
              >
                Register
              </button>
            </>
          )}
        </div>

        {/* Mobile hamburger */}
        <button
          onClick={handleMobileMenuToggle}
          className="md:hidden w-6 h-6 flex items-center justify-center text-xl text-purple-300 bg-purple-500 rounded"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? '×' : '☰'}
        </button>
      </header>

      {/* Mobile menu content */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-[#2a0f2f] border-b border-purple-800 px-4 py-2 animate-fadeIn">
          {isLoggedIn ? (
            <div className="flex flex-row items-center justify-center gap-3">
              <span className="text-purple-300 font-medium whitespace-nowrap h-7">
                Welcome, {userName}
              </span>
              <button
                onClick={handleLogout}
                className="rounded-md bg-rose-600 hover:bg-rose-700 w-7 h-7 flex items-center justify-center text-white"
                title="Logout"
              >
                ⏻
              </button>
            </div>
          ) : (
            <div className="flex flex-row items-center justify-center gap-6">
              <Link to="/login" className="text-purple-300 hover:text-yellow-300">
                Login
              </Link>
              <span className="text-purple-500">|</span>
              <Link to="/signup" className="text-purple-300 hover:text-yellow-300">
                Register
              </Link>
            </div>
          )}
        </div>
      )}


      {/* Top quick links */}
      <div className="bg-black text-white text-xs sm:text-sm py-2 mt-2">
        <div className="max-w-6xl mx-auto px-3 flex flex-wrap justify-center gap-2 text-m lg:text-lg">
          <Link to="/visigift-insights" className="hover:text-yellow-200">💭 About</Link>
          <Link to="/visigift-updates" className="hover:text-yellow-200">📊 Updates</Link>
          <Link to="/visigift-faq" className="hover:text-yellow-200">🤔 FAQ</Link>
          <Link to="/visigift-rules" className="hover:text-yellow-200">📝 Rules</Link>
        </div>
        {/* <div className="mt-3 flex flex-wrap justify-center gap-3 text-sm text-blue-500">
          <Link to="/think5whysistrusted" className="text-yellow-200 hover:text-yellow-300 text-[12px] lg:text-lg">
            🔒 Trusted & Secure Platform – ISO 9001, ISO 27001, SOC-2 Certified
          </Link>
        </div> */}
      </div>
      <div className="flex justify-center bg-black mb-2">
        <div className="grid grid-cols-4 lg:grid-cols-7 gap-1 justify-center">
          <Link
            to={"/ordeflow-home"}
            className="flex items-center justify-center text-center bg-gray-800 text-white hover:bg-gray-600 rounded-lg py-2 px-4 transition-all duration-200"
          >
            <FontAwesomeIcon icon={faRainbow} className="mr-2" />
            Public
          </Link>          
          <Link
            to={"/ordeflow-home"}
            className="flex items-center justify-center text-center bg-gray-800 text-white hover:bg-gray-600 rounded-lg py-2 px-4 transition-all duration-200"
          >
            <FontAwesomeIcon icon={faMapMarkerAlt} className="mr-2" />
            Local
          </Link>
          <Link
            to={"/ordeflow-home"}
            className="flex items-center justify-center text-center bg-gray-800 text-white hover:bg-gray-600 rounded-lg py-2 px-4 transition-all duration-200"
          >
            <FontAwesomeIcon icon={faCity} className="mr-2" />
            City
          </Link>
          <Link
            to={"/ordeflow-home"}
            className="flex items-center justify-center text-center bg-gray-800 text-white hover:bg-gray-600 rounded-lg py-2 px-4 transition-all duration-200"
          >
            <FontAwesomeIcon icon={faStar} className="mr-2" />
            Celebirity
          </Link>
          <Link
            to={"/visigift-dashboard"}
            className="flex items-center justify-center text-center bg-gray-800 text-white hover:bg-gray-600 rounded-lg py-2 px-4 transition-all duration-200"
          >
            <FontAwesomeIcon icon={faDashboard} className="mr-2" />
            Dashboard
          </Link>
          <Link
            to={"/visigift-scratch"}
            className="flex items-center justify-center text-center bg-gray-800 text-white hover:bg-gray-600 rounded-lg py-2 px-4 transition-all duration-200"
          >
            <FontAwesomeIcon icon={faTicketAlt} className="mr-2" />
            Scratch
          </Link>  
          <Link
            to={"/visigift-rewards"}
            className="flex items-center justify-center text-center bg-gray-800 text-white hover:bg-gray-600 rounded-lg py-2 px-4 transition-all duration-200"
          >
            <FontAwesomeIcon icon={faGifts} className="mr-2" />
            Rewards
          </Link>                  
        </div>
      </div>

      {/* Main content */}
      <main className="flex-grow mx-auto px-3 py-4 w-full justify-center items-center text-center">
        {/* Ad image */}
        <div className="flex justify-center bg-black py-2 px-4 mb-2">
          <img
            src={`/api/downloads/ads/roomanywhere.jpg`}
            alt="RoomAnywhere: No Image"
            className="w-full max-w-md h-auto object-cover rounded-lg shadow-lg"
          />
        </div>

        {/* Top buttons grid */}
        <div className="flex justify-center items-center bg-black py-2 mb-2">
          <div className="grid grid-cols-4 lg:grid-cols-8 gap-1 justify-center place-items-center">
            {menuButtons.map((btn, idx) => (
              <div key={idx} className="bottom-buttons-box">
                <Link
                  to={btn.link}
                  className="flex items-center justify-center text-center bg-gray-800 text-white hover:bg-gray-600 rounded-lg py-2 px-4 transition-all duration-200"
                >
                  <FontAwesomeIcon icon={btn.icon} className="mr-2" />
                  {btn.label}
                </Link>
              </div>
            ))}
          </div>
        </div>

        

        {/* Bottom buttons grid */}
        {/* <div className="flex justify-center bg-black border border-purple-500 py-2 mb-2">
          <div className="button-links grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 gap-4 justify-center">
            {menuButtonsBottom.map((btn, idx) => (
              <div key={idx} className={`bottom-buttons-box ${btn.className || ''}`}>
                <Link
                  to={btn.link}
                  className="flex items-center justify-center text-center bg-gray-800 text-white hover:bg-gray-600 rounded-lg py-2 px-4 transition-all duration-200"
                >
                  <FontAwesomeIcon icon={btn.icon} className={`mr-2 ${btn.className || ''}`} />
                  {btn.label}
                </Link>
              </div>
            ))}
          </div>
        </div> */}
      </main>

      {/* Footer */}
      <footer className="bg-[#2a0f2f] border-t border-purple-800 text-purple-300 py-4">
        <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-xs lg:text-sm">
            © 2025 Think5Whys Global DeepTech Solutions. All rights reserved.
          </div>
          <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
            <Link to="/about-us" className="text-white hover:text-purple-400">About</Link>
            <Link to="/privacy-policy" className="text-white hover:text-purple-400">Privacy Policy</Link>
            <Link to="/terms-of-use" className="text-white hover:text-purple-400">Terms of Use</Link>
            <Link to="/contact-us" className="text-white hover:text-purple-400">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default VisiGiftFAQ;